import React from 'react';

export default function HeadDoctorPageHeader({ badge, title, description, actions }) {
  return (
    <header className="hd-page-header hd-no-print mb-4">
      <div className="hd-page-header__main">
        <div className="hd-page-header__text">
          {badge && <span className="hd-page-header__badge">{badge}</span>}
          <h1 className="hd-page-title mb-1">{title}</h1>
          {description && <p className="hd-page-header__desc mb-0">{description}</p>}
        </div>
        {actions ? <div className="hd-page-header__actions">{actions}</div> : null}
      </div>
    </header>
  );
}
